// src/mixins/windowSizeMixin.js
import { jsonp } from "vue-jsonp";
import { mapState } from "vuex";

export default {
    data() {
        return {
            // isLoginState: false, // 登录状态检测
        };
    },
    created() {
        this.loginState(); // 初始化时检测登录状态
    },
    computed: {
        ...mapState(["userToken", "isLoginState"]), // 确保 Vuex 中有这些状态
    },
    methods: {
        // 检测用户登录状态
        loginState() {
            const loginStateUrl = "https://user.drcnet.com.cn/userapi/loginController/initLoginP?flag=initp";
            jsonp(loginStateUrl)
                .then((res) => {
                    if (res.UserToken != '') {
                        let loginState = res.Logined === 1;
                        this.$store.commit("setUserLoginState", loginState);
                        this.$store.commit("setUserAdv", res.IsAdv)
                            // 同时存储到 localStorage
                        if (loginState && res.UserToken) {
                            localStorage.setItem('userToken', res.UserToken);
                            localStorage.setItem('userName', res.UserName);
                        } else {
                            localStorage.removeItem('userToken');
                            localStorage.removeItem('userName');
                        }

                        this.SETUSERMESSAGE(res.UserToken || "", res.UserName, res.IsAdv);
                    } else {
                        this.$store.commit("setUserLoginState", false);
                        this.SETUSERMESSAGE("");
                        localStorage.removeItem('userToken');
                        localStorage.removeItem('userName');
                        this.$store.commit("setUserAdv", false)
                    }
                })
                .catch((err) => {
                    console.error("登录状态检测失败:", err);
                    this.$store.commit("setUserLoginState", false);
                    this.SETUSERMESSAGE("");
                    localStorage.removeItem('userToken');
                    localStorage.removeItem('userName');
                    this.$store.commit("setUserAdv", false)
                });
        },
        // 无权限提示
        NOPERMISSIONTIP() {
            this.$alert("当前无权限！", "提示", {
                confirmButtonText: "确定",
            });
        },

        // 更新用户登录状态和 Token
        SETUSERMESSAGE(token, username, IsAdv) {
            if (this.isLoginState && token) {
                this.$store.commit("updateUserToken", token);
                this.$store.commit("setUserLoginState", true);
                this.$store.commit("updateUserName", username); // 假设有一个更新用户名的 mutation
                this.$store.commit("setUserAdv", IsAdv)
            } else {
                this.$store.commit("updateUserToken", "");
                this.$store.commit("setUserLoginState", false);
                this.$store.commit("updateUserName", ""); // 假设有一个更新用户名的 mutation
                this.$store.commit("setUserAdv", false)
                this.$store.commit("setUserAdv", false)
            }
        },
    },
    // watch: {
    //     // 监听路由变化，重新检测登录状态
    //     $route() {
    //         this.loginState();
    //     },
    //     // 监听 userToken 变化，自动跳转登录页
    //     userToken(newToken) {
    //         if (!newToken && this.userLoginState) {
    //             this.$router.push({ path: "/login" }); // 改为跳转到 /login 更合理
    //         }
    //     },
    // },
};